/**
 * @generated SignedSource<<2f3d736cf894aa3d79a90124d0259c06>>
 * @relayHash 7d27fb44034aafa5944b28e41ade6185
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7d27fb44034aafa5944b28e41ade6185

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      },
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      }
    ],
    "kind": "ScalarField",
    "name": "checkContractReferences",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferencesResultQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReferencesResultQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7d27fb44034aafa5944b28e41ade6185",
    "metadata": {},
    "name": "ReferencesResultQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "f43736ae6a6a7b4b6de6aaa611c501e9";

export default node;
